import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  Box,
  Button,
  Card, CardContent, CardHeader,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Typography,
} from '@mui/material';
import cx from 'classnames';
import React, { useState } from 'react';

import i18n from 'FRONTEND/utils/i18n';

const AppointmentSupport = ({
  disableBackButton = false,
  isHelpButton = false,
  onBackClick = () => {},
  content,
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const handleDialogOpen = () => {
    setIsDialogOpen(true);
  };
  const handleDialogClose = () => {
    setIsDialogOpen(false);
  };

  const supportContent = content?.paragraphList?.map((paragraph) => {
    const Icon = paragraph.icon;
    return (
      <Box className='appointmentSupport-paragraphContainer' key={paragraph.title}>
        <Typography className='appointmentSupport-paragraphTitle' variant='h6' gutterBottom>
          <Icon className='appointmentSupport-icon' />{i18n._(paragraph.title)}
        </Typography>
        <Typography color='textSecondary' variant='body2' paragraph>
          {i18n._(paragraph.text)}
        </Typography>
      </Box>
    );
  });

  const classes = cx('appointmentSupport', { appointmentSupport_dialog: isHelpButton });

  return (
    <div className={classes}>
      {isHelpButton ? (
        <Button onClick={handleDialogOpen} startIcon={<InfoOutlinedIcon />}>
          {i18n._('Help')}
        </Button>
      ) : (
        <Card variant='outlined'>
          <CardHeader
            title={
              <div className='appointmentSupport-header'>
                <span className='appointmentSupport-headerIcon'>
                  <InfoOutlinedIcon />
                </span>
                {i18n._(content?.title)}
              </div>
            }
            subheader={i18n._(content?.text)}
            subheaderTypographyProps={{ variant: 'body2' }}
          />
          {!isHelpButton && (
            <CardContent>
              {supportContent}
            </CardContent>
          )}
        </Card>
      )}
      {isHelpButton && (
        <Dialog
          open={isDialogOpen}
          onClose={handleDialogClose}
        >
          <DialogTitle>{i18n._(content?.title)}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Typography variant='body2' paragraph>{i18n._(content?.text)}</Typography>
              {supportContent}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} autoFocus>{i18n._('Close')}</Button>
          </DialogActions>
        </Dialog>
      )}
    </div>
  );
};

export default AppointmentSupport;
